import React from 'react'
import PageHeader from '../../componentsII/PageHeader';
import api from '../../axios/api';
import { TableContainer, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Table, Paper, Switch, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { X, Trash2 as DeleteIcon, PenBoxIcon, PlusIcon } from 'lucide-react';
import { format } from "date-fns";
import CustomButton from '../../componentsII/Buttons';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../redux/slices/notificationSlice';
import AddUpdatePrimaryUsageModal from '../../components/Masters/PrimaryUsageMaster/AddUpdateLocationPrimaryUsageModal';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import debounce from 'lodash/debounce';
import { Search } from 'lucide-react';

const PrimaryUsageMaster = () => {
  const [primaryUsage, setPrimaryUsage] = useState([]);
  const [isAddUpdatePrimaryUsageModalOpen, setIsAddUpdatePrimaryUsageModalOpen] = useState(false);
  const [selectedPrimaryUsage, setSelectedPrimaryUsage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [PrimaryUsageTypeToDelete, setPrimaryUsageTypeToDelete] = useState(null);
  const dispatch = useDispatch();

  const [totalPrimaryUsage, setTotalPrimaryUsage] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    search: '',
    status: 'ALL',
    sortBy: 'created_at',
    sortOrder: 'desc'
  });

  const getAllPrimaryUsage = async (pageNumber = page, limit = rowsPerPage, filterParams = filters) => {
    try {
      const response = await api.get('/admin/getPrimaryUsage', {
        params: {
          page: pageNumber + 1,
          limit,
          search: filterParams.search,
          status: filterParams.status === 'ALL' ? '' : filterParams.status,
          sortBy: filterParams.sortBy,
          sortOrder: filterParams.sortOrder
        }
      });
      setPrimaryUsage(response.data.data);
      setTotalPrimaryUsage(response.data.total);
    } catch (error) {
      dispatch(showNotification({
        message: 'Failed to fetch Primary Usage',
        type: 'error',
      }));
    }
  }

  useEffect(() => {
    getAllPrimaryUsage();
  }, [page, rowsPerPage, filters]);

  const debouncedSearch = debounce((value) => { setFilters(prev => ({ ...prev, search: value })); setPage(0); }, 500);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRemove = async (id) => {
    const PrimaryUsageType = primaryUsage.find(type => type.id === id);
    setPrimaryUsageTypeToDelete(PrimaryUsageType);
    setDeleteDialogOpen(true);
  }

  const confirmDelete = async () => {
    try {
      setIsSubmitting(true);
      const response = await api.delete(`/admin/deletePrimaryUsage/${PrimaryUsageTypeToDelete.id}`);
      if (response.data.status == 200) {
        dispatch(showNotification({
          message: 'Primary Usage deleted successfully',
          type: "success"
        }));
        getAllPrimaryUsage();
      } else {
        dispatch(showNotification({
          message: 'Failed to delete Primary Usage',
          type: "error"
        }));
      }
    } catch (error) {
      console.error('Error deleting Primary Usage:', error);
      dispatch(showNotification({
        message: 'An error occurred while deleting',
        type: "error"
      }));
    } finally {
      setIsSubmitting(false);
      setDeleteDialogOpen(false);
      setPrimaryUsageTypeToDelete(null);
    }
  }

  const ActivateDeactivate = async (user) => {
    try {
      setIsSubmitting(true);
      const response = await api.post(`/admin/activateDeactivatePrimaryUsage/${user.id}`, {
        is_active: user.is_active == "1" ? 0 : 1
      });
      if (response.data.status == 200) {
        dispatch(showNotification({
          message: user.is_active ? 'Primary Usage deactivated successfully' : 'Primary Usage activated successfully',
          type: "success"
        }));
        getAllPrimaryUsage();
      } else {
        dispatch(showNotification({
          message: user.is_active ? 'Failed to deactivate Primary Usage' : 'Failed to activate Primary Usage',
          type: "error"
        }));
      }
    } catch (error) {
      console.error('Error activating/deactivating Primary Usage:', error);
      dispatch(showNotification({
        message: 'An error occurred',
        type: "error"
      }));
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleEdit = async (user) => {
    setSelectedPrimaryUsage(user);
    setIsAddUpdatePrimaryUsageModalOpen(true);
  }

  return (
    <>
      <PageHeader title="Primary Usage">
        <div className="flex justify-end gap-5 items-center mt-5">
          <div className="flex items-center gap-4 flex-1">
            {/* Search Field */}
            <TextField
              size="small"
              placeholder="Search primary usage types..."
              InputProps={{
                startAdornment: <Search className="w-5 h-5 text-gray-500 mr-2" />,
              }}
              onChange={(e) => debouncedSearch(e.target.value)}
              className="min-w-[300px]"
            />

            {/* Status Filter */}
            <FormControl size="small" className="min-w-[150px]">
              <InputLabel>Status</InputLabel>
              <Select
                value={filters.status}
                label="Status"
                onChange={(e) => {
                  setPage(0);
                  setFilters(prev => ({ ...prev, status: e.target.value }))
                }}
              >
                <MenuItem value="ALL">All</MenuItem>
                <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                <MenuItem value="INACTIVE">INACTIVE</MenuItem>
              </Select>
            </FormControl>

            {/* Sort By */}
            <FormControl size="small" className="min-w-[150px]">
              <InputLabel>Sort By</InputLabel>
              <Select
                value={filters.sortBy}
                label="Sort By"
                onChange={(e) => {
                  setPage(0);
                  setFilters(prev => ({ ...prev, sortBy: e.target.value }))
                }}
              >
                <MenuItem value="created_at">Created Date</MenuItem>
               <MenuItem value="primary_uage">Primary Usage Name</MenuItem>
              </Select>
            </FormControl>

            {/* Sort Order */}
            <FormControl size="small" className="min-w-[150px]">
              <InputLabel>Order</InputLabel>
              <Select
                value={filters.sortOrder}
                label="Order"
                onChange={(e) => {
                  setPage(0);
                  setFilters(prev => ({ ...prev, sortOrder: e.target.value }))
                }}
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </Select>
            </FormControl>
          </div>
          <CustomButton
            title='Add Industry Type'
            className="bg-green-600 hover:bg-green-700 text-white"
            text={<><PlusIcon /> Add Primary Usage</>}
            click={() => setIsAddUpdatePrimaryUsageModalOpen(true)}
          />
        </div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Primary Usage Name</TableCell>
                <TableCell>Is Active</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {primaryUsage?.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.primary_uage}</TableCell>
                  <TableCell>
                    <Switch
                      checked={user.is_active == "0" ? false : user.is_active == "1" ? true : null}
                      color='success'
                      onChange={(e) => ActivateDeactivate(user)}
                      disabled={isSubmitting}
                    />
                  </TableCell>
                  <TableCell>
                    {user.created_date ? format(new Date(user.created_date), "dd-MM-yyyy") : ""}
                  </TableCell>
                  <TableCell sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton
                      size="small"
                      onClick={() => handleEdit(user)}
                      sx={{
                        backgroundColor: '#16A34A',
                        color: 'white',
                        '&:hover': { backgroundColor: '#00bf46' },
                        p: '8px',
                      }}
                    >
                      <PenBoxIcon size={20} />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleRemove(user.id)}
                      sx={{
                        backgroundColor: '#df3e3e',
                        color: 'white',
                        '&:hover': { backgroundColor: '#ff0000' },
                        p: '8px',
                      }}
                    >
                      <DeleteIcon size={20} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  colSpan={4}
                  count={totalPrimaryUsage}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelDisplayedRows={({ from, to, count }) => 
                    `Page ${page + 1} of ${Math.ceil(count / rowsPerPage)} | ${from}-${to} of ${count}`
                  }
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>

        <Dialog
          open={isAddUpdatePrimaryUsageModalOpen}
          onClose={() => { setIsAddUpdatePrimaryUsageModalOpen(false); setSelectedPrimaryUsage(null) }}
          maxWidth="sm"
          fullWidth
        >
          <div className="flex justify-between items-start pt-2 px-2">
            <DialogTitle className="text-lg font-bold mt-1">
              {selectedPrimaryUsage ? "Edit Primary Usage" : "Add New Primary Usage"}
            </DialogTitle>
            <X
              className="w-6 h-6 cursor-pointer text-gray-500 hover:text-gray-700 transition"
              onClick={() => { setIsAddUpdatePrimaryUsageModalOpen(false); setSelectedPrimaryUsage(null) }}
            />
          </div>
          <DialogContent >
            <AddUpdatePrimaryUsageModal
              refetch={getAllPrimaryUsage}
              onClose={() => {
                setIsAddUpdatePrimaryUsageModalOpen(false);
                setSelectedPrimaryUsage(null);
              }}
              primaryUsageId={selectedPrimaryUsage?.id}
              initialData={selectedPrimaryUsage}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete the equipment type "{PrimaryUsageTypeToDelete?.industry_name}"? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <div className="flex justify-end gap-5 items-center mt-5">
              <CustomButton
                className="bg-gray-500 hover:bg-gray-700 text-white"
                text="Cancel"
                disabled={isSubmitting}
                click={() => setDeleteDialogOpen(false)}
              />
              <CustomButton
                className="bg-red-600 hover:bg-red-700 text-white"
                click={confirmDelete}
                text='Delete'
                disabled={isSubmitting}
              />
            </div>
          </DialogActions>
        </Dialog>
      </PageHeader>
    </>
  )
}

export default PrimaryUsageMaster